import { Slide, Typography, Grid } from '@mui/material';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import colors from '../../colors';
import { selectUserInfo } from '../../../features/userInfo/userInfoSlice';
import React from 'react'
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Collapse from '@mui/material/Collapse';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate }  from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setIsUpgrading} from '../../../features/registration/registrationSlice'
import { selectGlobalDataState } from '../../../features/global/globalDataSlice';
import { texts } from '../../general/texts';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  })
}));

export const FinishRegistration = ({ isDialogOpened, handleCloseDialog }) => {

  const [expanded, setExpanded] = React.useState(false);
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const userInfo = useSelector(selectUserInfo)
  const globalDataSliceState = useSelector(selectGlobalDataState)
 
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    //setOpen(true);
    //setTimeout(() => setOpen(false), 16000);
  };

  const handleClose = () => {
    //setOpen(false);
    handleCloseDialog(false);
  };

  const handleButtonClick = () => 
  {
    dispatch(setIsUpgrading(true))
    navigate('/register')
    //navigate('/register', {state:{step: 3, isUpgrading: true}})
  }

  React.useEffect(() => {
    handleClickOpen();
  }, []);

return (
  <div>
    {/* <Button variant="outlined" onClick={handleClickOpen}>
      Slide in alert dialog
    </Button> */}
    <Dialog
      open={isDialogOpened}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      fullScreen={true}
      PaperProps={{style: { borderRadius: '20px', marginTop:'10%', width:'100%'}}}
      aria-describedby="alert-dialog-slide-description"
    >
        <Grid container justifyContent={'right'} ><Button onClick={handleClose} sx={{color:colors.orange,mt:'2%', mr:'1%', borderRadius:'10px', height:'3vh'}} ><CloseIcon /></Button></Grid>
      <DialogTitle sx={{color:colors.darkBlue, textAlign:'center', fontFamily:'GerberaBold', fontSize:'2rem'}} >{texts["title-complete-registration"]}</DialogTitle>
      <DialogContent  >
        <DialogContentText sx={{color:colors.gray, textAlign:'center', fontFamily:'GerberaMedium'}} id="alert-dialog-slide-description">
          {texts["message-complete-registration"]}
        </DialogContentText>
        <Grid container justifyContent={' center'} sx={{pt:'5%','@media (max-width: 899px)' : {pb:'15%'}}} >
          <Card elevation={0} sx={{ width:'35%', borderRadius:'10px', backgroundColor:colors.cyan,'@media (max-width: 899px)' : {width:'90%'}}}>
              {expanded === false &&
                  <Grid container  pt={'3%'} pb={'3%'}>
                  <Grid container item md={2} xs={2} justifyContent={'left'} ><Avatar sx={{backgroundColor:'white', color:colors.gray, ml:'15%'}} alt={userInfo.name}/></Grid>
                  <Grid container item md={8} xs={8} justifyContent={'left'}  >
                      <Grid container item md={12} xs={12} direction="row" justifyContent="flex-start" alignItems="center" >
                          <Typography  sx={{color:colors.darkBlue, fontFamily:'GerberaBold', fontSize:'1rem'}} >{userInfo.name}</Typography>
                      </Grid>
                  </Grid>
                  <Grid container item md={2} xs={2} sx={{pr:'5%'}} >
                      <ExpandMore expand={expanded} onClick={handleExpandClick} aria-expanded={expanded} aria-label="show more" >
                          <ExpandMoreIcon color='warning' />
                      </ExpandMore>
                  </Grid>
              </Grid>
              }

          {expanded === true &&
              <Grid container  pt={'3%'} pb={'3%'} sx={{background:colors.gradientOrange, color:colors.white}} >
              <Grid container item md={2} xs={2} justifyContent={'left'} ><Avatar sx={{backgroundColor:'white', color:colors.gray, fontWeight:'bold', ml:'15%'}} alt={userInfo.displayName}/></Grid>
              <Grid container item md={8} xs={8} justifyContent={'left'}  >
                  <Grid container item md={12} xs={12} direction="row" justifyContent="flex-start" alignItems="center" >
                      <Typography  sx={{ fontFamily:'GerberaBold', fontSize:'1rem'}} >{userInfo.name}</Typography>
                  </Grid>
              </Grid>
              <Grid container item md={2} xs={2} sx={{pr:'5%'}} >
                  <ExpandMore expand={expanded} onClick={handleExpandClick} aria-expanded={expanded} aria-label="show more" >
                      <ExpandMoreIcon style={{color:colors.white}}/>
                  </ExpandMore>
              </Grid>
          </Grid>
          }
              <Collapse in={expanded} timeout="auto" unmountOnExit>
                  <CardContent>
                      <Grid container rowSpacing={5} pt={'5%'} >
                          <Grid container item md={12} xs={12} rowSpacing={5} >
                              <Grid item md={4} xs={6}>
                                  <Typography sx={{color:colors.orange, fontSize:'1rem', fontFamily:'GerberaMedium'}} >{texts["title-full-name"]}:</Typography>
                                  <Typography sx={{color:colors.darkBlue, fontSize:'0.85rem', pt:'3%', fontFamily:'GerberaLight'}} >{userInfo.name}</Typography>
                              </Grid>
                              <Grid item md={4} xs={6}>
                                  <Typography sx={{color:colors.orange, fontSize:'1rem', fontFamily:'GerberaMedium'}}>{texts["placeholder-city"]}:</Typography>
                                  <Typography sx={{color:colors.darkBlue, fontSize:'0.85rem', pt:'3%', fontFamily:'GerberaLight'}}>{userInfo.city}</Typography>
                              </Grid>
                              <Grid item md={4} xs={6}>
                                  <Typography sx={{color:colors.orange, fontSize:'1rem', fontFamily:'GerberaMedium'}}>{texts["placeholder-address"]}:</Typography>
                                  <Typography sx={{color:colors.darkBlue, fontSize:'0.85rem', pt:'3%', fontFamily:'GerberaLight'}}>{userInfo.address}</Typography>
                              </Grid>
                          </Grid>
                      </Grid>
                  </CardContent>
              </Collapse>
          </Card>
        </Grid>
        <DialogActions>
              <Grid container justifyContent={'center'} >
                  <Grid container item md={12} xs={12} justifyContent={'center'}>
                      <Button  onClick={handleButtonClick} sx={{position: 'fixed', bottom: 10, background:colors.gradientOrange, color:colors.white, fontSize:'0.9rem', fontFamily:'GerberaBold', textTransform:'none', fontSize:'1rem', width:'10%','@media (max-width: 899px)' : {width:'30%'} }} >{texts["button-continue"]}</Button>
                  </Grid>
              </Grid>
        </DialogActions>
      </DialogContent>
    </Dialog>
  </div>
)
}
export default FinishRegistration